/**
 * Whether the document is currently being left (reload, navigation). Requests still in flight at
 * that moment are cancelled by the browser, and such a cancellation is not a failure worth logging.
 *
 * Extracted from `abstract-o2d-timeline.view.ts`, where it was introduced by 37704775 for the
 * timeline's start cursor. It lives here because a second caller needs it
 * (`user-display-name.controller.ts`) and importing it from a view would drag that view's whole
 * dependency chain into the caller — which has broken unrelated unit tests in this app before.
 * One source, so the two cannot drift apart.
 *
 * Measured 2026-09-16: `pagehide` fires BEFORE the cancelled fetch rejects, so the flag is already
 * set when a page-leave rejection arrives at the catch block.
 */
let pageLeaving = false;

if (typeof window !== 'undefined') {
    window.addEventListener('pagehide', () => { pageLeaving = true; });
    window.addEventListener('pageshow', () => { pageLeaving = false; });
}

/** True between `pagehide` and a later `pageshow`; see the module comment. */
export function isPageLeaving(): boolean {
    return pageLeaving;
}
